import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CustomSelect from "../CustomComponents/CustomSelect";
import Autocomplete from '@mui/material/Autocomplete';
import { PropListItem } from "../CustomComponents/PropListItem";
import { makeStyles } from "@mui/styles";
import {logger} from '../../utils';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            color: "#ffffff",
            overflowy: "hidden"
        },
        "& .Mui-checked": {
            color: "#1f1b1e"
        },
        "& .MuiSvgIcon-root": {
            color: "#1f1b1e",
            colorPrimary: "#1f1b1e",
            fill: "#1f1b1e",
        },
        "& .MuiTypography-root": {
            color: "#000000"
        },
        "& .MuiMenu-paper": {
            color: "#000000"
        },
        "& .MuiFormControl-root": {
            color: "#000000"
        },
    },
 
}));

export default function TaskPropDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [ValueAlert, setAlert] = React.useState(false);
    const [saveAlert, setSaveAlert] = React.useState(false);
    const [newItem, setNewItem] = React.useState('');
    const [radio, setRadio] = React.useState('');
    const classes = pageStyles();


    const [ProjectChoices, setProjectChoices] = React.useState([])
    const [ProjectOption, setProjectOption] = React.useState('')
    
    const [ProjectGroupChoices, setProjectGroupChoices] = React.useState([])
    const [ProjectGroupOption, setProjectGroupOption] = React.useState('')

    const [TaskGroupChoices, setGroupChoices] = React.useState([])
    const [TaskGroupOption, setTaskGroupOption] = React.useState('')
    const [taskItemChoices, setTaskItemChoices] = React.useState([]);


    const [optionList, setOptionList] = React.useState([]); 

    const [costCenterChoices, setCostCenterChoices] = React.useState([]);
    const [costCenterID, setCostCenterID] = React.useState('');
    
    const [updateName, setUpdateName] = React.useState('');
  	
    const initialValues = {
        Name: updateName,
        Project: ProjectOption,
        TaskGroup: TaskGroupOption,
        ProjectGroupID: ProjectGroupOption,
        IsActive: true,
        IsBillable: true,
        costCenter: 0,
        propList: optionList
    };

    const validFormSchema = Yup.object({
        Name: Yup
            .string('Enter a name for this Task')
            .required('Name is required'),
        Project: Yup
            .string('Please enter the Project.')
            .required('Project is required'),
        ProjectGroupID: Yup
            .string('Please enter the ProjectGroup.')
            .required('ProjectGroup is required'),
        TaskGroup: Yup
            .string('Please enter the Task Group.')
            .required('Task Group is required'),
        costCenter: Yup
            .string('Please enter the costCenter')
            .required('costCenter is required'),
        IsActive: Yup
            .boolean(),
        IsBillable: Yup
            .boolean(),
        propList: Yup.array().of(
            Yup.object().shape({
                
            })
        )

    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.Name,
            ProjectID: values.Project,
            CostCenterID: costCenterID,
            GroupID: values.TaskGroup,
            IsActive: values.IsActive,
            IsBillable: values.IsBillable,
            PropList: values.propList
        };

        handleDialogCallback(msg);

        handleClose();
    })

    const handleClickOpen = () => {
		setUpdateName('')
        setOpen(true)
        setRefresh(true)
    };

    const handleClose = () => {
        setOpen(false);
        setProjectGroupOption('');
        setProjectOption('');
        setTaskGroupOption('');
        setTaskItemChoices([]);
        setCostCenterID('');
        setOptionList([]);
        setGroupChoices([]);
        setNewItem('');
    };

    const handleAlert = (value, VariableID, VariableName) => {
    const itemExists = taskItemChoices.some(
        taskItem => taskItem.TaskVariableID === VariableID && taskItem.label === value
    );

    if (!itemExists) {
        setNewItem({ Name: value, TaskVariableID: VariableID, VariableName: VariableName, isNew : true});        
        setAlert(true);
    } else {
        logger("Item already exists, no need to trigger alert.");
    }
};

    const handleAlertClose = () => {
        setAlert(false);
    };

    const handleSaveAlertClose = () => {
        setSaveAlert(false)
    };

    const setProject = (json) => {
        
        let choices = [];
            json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))			
        setProjectChoices(choices)
    }
    
    const setProjectGroup = (json) => {
   //   logger(`set PG Choices`)
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setProjectGroupChoices(choices)
    }

    const setTaskGroup = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.GroupID }))
        setGroupChoices(choices)
    }

    const setTaskItem = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, TaskVariableID: choice.TaskVariableID}))
        setTaskItemChoices(choices)
    }


    function handleChange(event) {
        setTaskGroupOption(event.target.value)
        fetch(`/api/task_variable/${event.target.value}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                
                setOptionList(json)
               // initialValues.propList = json;
                
            });    
        setRefresh(true);
    };
    
    function handleProjectGroupChange(event) {
        //	initialValues.ProjectGroupID = event.target.value;
        setProjectGroupOption(event.target.value);

        fetch(`/api/project/limiteddropdown/${event.target.value}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                setProject(json)
            })
    }
    
    function handleCostCenterChange(event){
		setCostCenterID(event.target.value);
	}
	         
	
	function handleProjectChange(event){
		setProjectOption(event.target.value);
	}

    function handleNewItem(Name, TaskVariableID) {
        fetch("api/taskItem", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "taskItem": {
                    "Name": Name,
                    "TaskVariableID": TaskVariableID,
                }
            })
        })
        setRefresh(true);
    };

    const GetTask = async () => {
        const response = await fetch(`/api/Task/dropdown`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                return json;
            });
        return response;
    }

    const CheckTask = async (taskList, task) => {
      //logger(taskList)
      //logger(task)
        let output = false;

        taskList.forEach((item, index) => {
            if (item.Name === task.Name) {
                setSaveAlert(true);
                output = true;
            }
        })

        if (!output) {
            onTrigger(task);
         // logger('will be saved')
        }
    }

    const setCostCenter = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setCostCenterChoices(choices)
    }
    
	const setTaskPropItemValue = (p, props, index) => {
		logger("Props values in my function", props.values)
		logger("newItem in my function", newItem )
		var TkItem = taskItemChoices.filter(taskItem => taskItem.TaskVariableID === p.TaskVariableID && taskItem.label === newItem.Name && newItem.isNew === true )
		logger("tkitem", TkItem)
		if (TkItem.length > 0) {
			props.values.propList[index].TaskItem = TkItem[0].value;
			//logger("updateProps", updateProps)
			const updateProp = props.values.propList
			logger("updateProp", updateProp)
			setOptionList(updateProp);
			logger("Props values end of function--", props.values)
		} else {
			TkItem = null;
			logger("TkItem is empty or undefined");
		}
	}

    React.useEffect(() => {
        if (refresh) {
			
            fetch('/api/cost_center/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setCostCenter(json));

            if (!TaskGroupChoices.length) { 
            fetch('/api/task_group/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setTaskGroup(json));
            }

            fetch('api/task_prop_item', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => { setTaskItem(json) });

            if (!ProjectGroupChoices.length) { 
         //     logger(`fetch for projectgroups`)
            fetch('/api/projectGroup', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setProjectGroup(json));
            }

       //   logger(`TGOption`, TaskGroupOption)
        //  logger(`PGOption`, ProjectGroupOption)
        //  logger(`ProjOption`, ProjectOption)

            setRefresh(false);
        }
    })

    return (
        <div> 
            <Button variant="contained" onClick={handleClickOpen}>
                Add Task
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">

                <DialogContent>                 
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={validFormSchema}
                        validateOnChange={false}
                        onSubmit={(values, { resetForm }) => {
                            GetTask()
                                .then(response => CheckTask(response, values))
                                .then(resetForm())
                       
                        }}
                    >
                        {props => (

                            <Form>
                                {logger("props.values", props.values)}
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
                                            Task
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                
                                <DialogTitle className={classes.root}>Task Info:</DialogTitle>                            
                                    <Grid container spacing={1} pl={1}>
                                    <Grid item xs={3}>  
                                        <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel>Task Type</InputLabel>
                                        <Select
                                            name="TaskGroup"
                                            id="outlined-TaskGroup"
                                            labelId="outlined-TaskGroup"
                                            label="TaskType"
                                            className={classes.root}
                                            //options={TaskGroupChoices}
                                            onChange={handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.TaskGroup}
                                            error={props.touched.TaskGroup && Boolean(props.errors.TaskGroup)}
                                            helperText={props.touched.TaskGroup && props.errors.TaskGroup}
                                        >
                                            {TaskGroupChoices.map((Choice, i) => {
                                                return (                                               
                                                    <MenuItem key={i} value={Choice.value} disabled={props.values.TaskGroup == '' ? false : true}>{Choice.label}</MenuItem>
                                                );

                                            })}
                                        </Select>
                                         {props.touched.TaskGroup && Boolean(props.errors.TaskGroup) &&
													<FormHelperText error={true}>Please enter TaskType</FormHelperText>}
                                            
                                        </FormControl>
                                        </div>
                                        <div>
                                            <FormControl sx={{ m: 1, width: 240 }}>
                                                <InputLabel>Cost Center</InputLabel>
                                                <Select
                                                    name="costCenter"
                                                    id="outlined-costCenter"
                                                    onChange={handleCostCenterChange}
                                                    onBlur={props.handleBlur}
                                                    value={costCenterID}
                                                    error={props.touched.costCenter && Boolean(props.errors.costCenter)}
                                                    helperText={props.touched.costCenter && props.errors.costCenter}
                                                    //options={costCenterChoices}
                                                    label="CostCenter"
                                                >
	                                                {costCenterChoices.map((Choice, i) => {
	                                                        return (
	                                                            <MenuItem key={i} value={Choice.value}>{Choice.label}</MenuItem>
	                                                        );
	
	                                                    })}
                                            </Select>
                                             {props.touched.costCenter && Boolean(props.errors.costCenter) &&
													<FormHelperText error={true}>{props.errors.costCenter}</FormHelperText>}
                                            </FormControl>
                                        </div>

                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel>ProjectGroup</InputLabel>
                                        <Select
                                            name="ProjectGroupID"
                                            id="outlined-ProjectGroupID"
                                           // options={ProjectGroupChoices}
                                            onChange={handleProjectGroupChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.ProjectGroupID}
                                            error={props.touched.ProjectGroupID && Boolean(props.errors.ProjectGroupID)}
                                            helperText={props.touched.ProjectGroupID && props.errors.ProjectGroupID}
                                            label="ProjectGroupID"  
                                                >  
                                                    {ProjectGroupChoices.map((Choice, i) => {
                                                        return (
                                                            <MenuItem key={i} value={Choice.value} disabled={props.values.TaskGroup == '' ? true : false}>{Choice.label}</MenuItem>
                                                        );

                                                    })}
                                        </Select>
                                         {props.touched.ProjectGroupID && Boolean(props.errors.ProjectGroupID) &&
													<FormHelperText error={true}>{props.errors.ProjectGroupID}</FormHelperText>}
                                    </FormControl>
                                          
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel>Project</InputLabel>
                                        <Select
                                            name="Project"
                                            id="outlined-Project"
                                            labelId="outlined-Project"
                                            label="Project"
                                            //options={ProjectChoices}
                                              onChange={handleProjectChange }
                                            onBlur={props.handleBlur}
                                            value={props.values.Project}
                                            error={props.touched.Project && Boolean(props.errors.Project)}
                                            helperText={props.touched.Project && props.errors.Project}
                                                >              
                                                    {ProjectChoices.map((Choice, i) => {
                                                return (
                                                    <MenuItem key={i} value={Choice.value} disabled={props.values.ProjectGroupID == '' ? true : false}>{Choice.label}</MenuItem>
                                                );

                                            })}
                                        </Select>
                                          {props.touched.Project && Boolean(props.errors.Project) &&
													<FormHelperText error={true}>{props.errors.Project}</FormHelperText>}
                                    </FormControl>
                                        </div>
                                        <div>
                                            <FormControl sx={{ m: 1, width: 240 }}>
                                                <TextField
                                                    name='Name'
                                                    id="outlined-taskProp"
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.Name}
                                                    disabled={props.values.TaskGroup == '' ? true : false}
                                                    error={props.touched.Name && Boolean(props.errors.Name)}
                                                    helperText="AutoSet by selecting a Radio Button before setting Property"
                                                    label="Name"
                                                />
                                            </FormControl>
                                        </div>
                                <div>
                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsActive"
                                        label="Active"
                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} disabled={props.values.TaskGroup == '' ? true : false} />}
                                    />
                                    </FormControl>
                                </div>
                                <div>
                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsBillable"
                                        label="Billable"
                                        control={<Checkbox checked={props.values.IsBillable} onChange={props.handleChange} disabled={props.values.TaskGroup == '' ? true : false} />}
                                    />
                                </FormControl>
                                        </div>

                                    </Grid>
                                    <Grid item xs={8}>
										<FieldArray name="propList">
											{({ push, remove }) => (
												<div>
													<RadioGroup
														name="radio-buttons-group"
														value={radio}
														onChange={(event) => {
															setRadio(event.target.value)
														}}
													>
														{logger("propList[index].taskItem)----", props.values)}
														{props.values.propList.map((p, index) => {
															const TaskItem = `propList[${index}].TaskItem`;
															const touchedTaskItem = getIn(props.touched, TaskItem);
															const errorTaskItem = getIn(props.errors, TaskItem);
															setTaskPropItemValue(p, props, index);
															return (
																<div>
																	<FormControl sx={{ m: 1, width: 240, display: "flex", flexDirection: "row" }}>
																		<FormControlLabel value={p.Name} control={<Radio />} />
																		<Autocomplete
																			freeSolo={true}
																			key="outlined-TaskItem-{index}"
																			id="outlined-TaskItem-{index}"
																			name={TaskItem}
																			options={taskItemChoices.filter(taskItem => taskItem.TaskVariableID == p.TaskVariableID)}
																			getOptionLabel={(option) => option?.label || option?.toString() || ''} // Ensure a string is returned
																			style={{ width: 300 }}
																			defaultValue={taskItemChoices.filter(taskItem => taskItem.value == initialValues.propList[index].TaskItem)[0]}
																			onInputChange={(e) => {
																				if (e) {
																					logger("onInputChange", e);
																					setNewItem({ Name: e.target.value, TaskVariableID: p.TaskVariableID, VariableName: p.Name, isNew: taskItemChoices.filter(taskItem => taskItem.label == e.target.value).length > 0 ? false : true });
																				} else {
																					logger("onInputChange: event is null");
																				}
																			}}
																			onChange={(e, value) => {
																				logger("Event", e);
																				logger("Selected Value", value);
																				if (!value || value.value === undefined) {
																					logger(`Name: ${p.Name} TaskVariableID: ${p.TaskVariableID} value: ${value} `);
																					const itemExists = taskItemChoices.some(
																						taskItem => taskItem.TaskVariableID === p.TaskVariableID && taskItem.label === value
																					);

																					if (!itemExists && value) {
																						setNewItem({ Name: value, TaskVariableID: p.TaskVariableID, VariableName: p.Name, isNew: true });
																						setAlert(true);
																					} else {
																						setNewItem({ Name: value, TaskVariableID: p.TaskVariableID, VariableName: p.Name, isNew: false });
																						logger("Item already exists, no need to trigger alert.");
																					}

																				} else {
																					logger("Existing item selected:", value);
																					logger("P.Name", p.Name)
																					logger("Radio", radio)																																								
																					if (p.Name === radio) {
																						const newName = `${p.Name}-${value.label}`;
																						logger("Setting Name to:", newName);
																						props.setFieldValue("Name", newName, false);
																						logger("Setting Name After :",newName);
																					}
																					props.setFieldValue(
																						`${TaskItem}`,
																						value !== null ? value.value : initialValues.propList[e].TaskItem
																					);

																					setNewItem({ Name: value.label, TaskVariableID: p.TaskVariableID, VariableName: p.Name, isNew: false });
																				}
																			}}

																			renderInput={params => (
																				<>
																					<TextField
																						margin="normal"
																						label={p.Name}
																						name={TaskItem}
																						{...params}
																					/>
																				</>

																			)}
																		/>

																		<Tooltip title="SAVE" placement="top-end">
																			<IconButton
																				color="primary"
																				sx={{ p: '10px' }}
																				aria-label="AddNewOption"
																				//disabled={!(newItem && newItem.TaskVariableID == p.TaskVariableID && newItem.isNew)}
																				disabled={newItem.TaskVariableID == p.TaskVariableID && taskItemChoices && (taskItemChoices.filter(taskItem => taskItem.label == newItem.Name).length > 0 ? false : true) ? false : true}
																				onClick={() => {
																					logger("newItem", newItem);
																					handleAlert(newItem.Name, newItem.TaskVariableID, newItem.VariableName,radio);
																				}}
																			>
																				<AddCircleOutlineIcon />
																			</IconButton>
																		</Tooltip>
																		<Dialog
																			open={ValueAlert}
																			onClose={handleAlertClose}
																			aria-labelledby="alert-dialog-title"
																			aria-describedby="alert-dialog-description"
																		>
																			<DialogTitle id="alert-dialog-title">
																				{"Save New value"}
																			</DialogTitle>
																			<DialogContent>
																				<DialogContentText id="alert-dialog-description">
                                                                        Add {newItem.Name} To {newItem.VariableName}
                                                                    </DialogContentText>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button onClick={() => { setAlert(false) }}>Disagree</Button>
                                                                    <Button onClick={() => {
                                                                        setAlert(false);
                                                                        handleNewItem(newItem.Name, newItem.TaskVariableID,newItem.VariableName,radio);
                                                                        logger("p.Name,radio", newItem.VariableName,"------" , radio, "----", )
                                                                        	if (newItem.VariableName === radio) {
																						const newName = `${newItem.VariableName}-${newItem.Name}`;
																						logger("Setting Name to:", newName);
																						//props.setFieldValue("Name", newName, false);
																						setUpdateName(newName)
																						logger("props.values.Name}", props.values.Name)
																					}
                                                                    }} autoFocus>
                                                                        Agree
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                        </FormControl>
                                                    </div>
                                                );
                                            })}
                                            </RadioGroup>
                                        </div>
                                    )}
                                        </FieldArray>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                <Dialog
                    open={saveAlert}
                    onClose={handleSaveAlertClose}
                    aria-labelledby="alert-title"
                    aria-describedby="alert-description"
                >
                    <DialogTitle id="alert-title">
                        {"SAVE FAILED"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-description">
                            The TASKNAME already exists, please select a unique TASKNAME
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setSaveAlert(false) }}>close</Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
           
        </div>
    );
}